import script from "./ViewWorkOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWorkOrder.vue?vue&type=script&setup=true&lang=js"

import "./ViewWorkOrder.vue?vue&type=style&index=0&id=82f36250&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82f36250"]])

export default __exports__